import app from '../app';
import Modal from '../../common/components/Modal';
import Button from '../../common/components/Button';
import Stream from '../../common/utils/Stream';
import alertUtil from './alertUtil';
import classList from '../../common/utils/classList';
import Alert, { AlertAttrs } from '../../common/components/Alert';
import LinkButton from '../../common/components/LinkButton';

export default class BindRoleModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.results = this.attrs.results
  }

  className() {
    return 'NickameModal Modal--small dl-modal-small';
  }

  title() {
    // return app.translator.trans('dl-person.forum.changeSignNameModal.title');
  }

  view() {
    if (this.alertAttrs) {
      this.alertAttrs.dismissible = false;
    }

    return (
      <div className={classList('Modal modal-dialog fade Modal-sign-container Modal-bind-role', this.className())}>
        <div className="Modal-sign-content">{this.content()}</div>
      </div>
    );
  }

  content() {
    return (
      <div className="Modal-sign-body">
        <div className="header">
          <div className="title">{app.translator.trans('dl-response.forum.BindRoleModal.tips')}</div>
        </div>
        <div className="content">
          {/* <div className="top">已连续签到3天，额外获得1积分</div> */}
          <div className="bottom"><p>{app.translator.trans('dl-response.forum.BindRoleModal.text_one')}</p>
          <p>{app.translator.trans('dl-response.forum.BindRoleModal.text_two')}</p></div>
        </div>
        <div className="footer">
            <Button className="btn" onclick={() => app.modal.close()} >{app.translator.trans('dl-response.forum.BindRoleModal.no')}</Button>
            <LinkButton className="btn" href={app.route.user(app.session.user)} onclick={() => app.modal.close()}>{app.translator.trans('dl-response.forum.BindRoleModal.yes')}</LinkButton>
        </div>
      </div>
    );
  }

}
